import axios from 'axios';
import qs from 'qs';
const {
    QUOTATION_API: quotationApi,
    QUOTATION_API_SECRET: quotationApiSecret
  } = window.globalConfig || {};
  

class Quotation {
    constructor() {
        this.url = quotationApi;
        this.secret = quotationApiSecret;
        
        this.axiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                'x-access-token': this.secret,
                
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    async createCompany(payload) {
        const data = qs.stringify(payload);
        return await this.axiosInstance.post('/empresa', data);
    }

    async getCompanyByCnpj(cnpj) {
        const sanitizedCnpj = cnpj.replace(/\//g, '_');
        return this.axiosInstance.get(`/empresa/cnpj/${sanitizedCnpj}`);
    }


    async createPlanQuotation(payload) {
        const data = qs.stringify(payload);
        return await this.axiosInstance.post(`/plano/${payload.client_id}`, data);
    }

    async updatePlanQuotation(payload) {
        const data = qs.stringify(payload);
        return await this.axiosInstance.patch(`/plano/${payload.plan_id}`, data);
    }

    async getPlanQuotationByCompany(client_id) {
        return await this.axiosInstance.get(`/plano/empresa/${client_id}`);
    }

    async deletePlanQuotation(plan_id) {
        return await this.axiosInstance.delete(`/plano/${plan_id}`);
    }

    async createFipe(payload) {
        const data = qs.stringify(payload);
        return await this.axiosInstance.post(`/fipe/${payload.plano}`, data);
    }


    async updateFipe(payload) {
        const data = qs.stringify(payload);
        return await this.axiosInstance.patch(`/fipe/${payload.id}`, data);
    }


    async deleteFipe(fipe_id) {
        return await this.axiosInstance.delete(`/fipe/${fipe_id}`);
    }

    async createMultipleFipe(payload) {
        return await this.axiosInstance.post(
            `/fipe/${payload.plano}/batch`,
            payload.data,
            { headers: { 'Content-Type': 'application/json' } }
        );
    }

}

export default new Quotation();